module.exports = __webpack_public_path__ + "21-o2.jpg?565a1431a5d04d8132e56d770db75e17";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/21-o2.jpg
// module id = 643
// module chunks = 0